import { render } from "./logo.svg?vue&type=template&id=2446e56a?inline"
const script = {}
script.render = render

export default script